<template>
	<div class="pui-form">
		<!--  -->
		<v-form @submit.prevent class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation v-if="modelLoaded">
			<v-layout wrap class="pui-form-layout"></v-layout>
			<!-- TabModel principal -->
			<div row wrap class="pui-form-layout">
				<v-tabs v-model="tabmodel" class="ml-3 mb-3" slider-color="primary" lazy>
					<v-tab :key="0" :href="'#tabControl'">{{ $t('tab.tabControl') }}</v-tab>
					<v-tab :key="1" :href="'#newsGallery'" v-if="!isCreatingElement">{{ $t('tab.newsGallery') }}</v-tab>
				</v-tabs>

				<v-tabs-items v-model="tabmodel">
					<!-- Tab 0 Informacion general -->
					<v-tab-item :key="0" :value="`tabControl`" lazy style="padding-left: 2">
						<pui-field-set>
							<v-layout wrap>
								<v-flex xs12 md6 lg6>
									<pui-text-field
										:label="$t('news.netrtitle')"
										v-model="model.netrtitle"
										toplabel
										required
										maxlength="100"
									></pui-text-field>
								</v-flex>
								<v-flex xs12 md3 lg3>
									<pui-date-field
										:label="$t('news.newsdate')"
										v-model="model.newsdate"
										toplabel
										required
										:time="true"
									></pui-date-field>
								</v-flex>
								<v-flex md4 lg3 xs3>
									<statusselectcomponent
										:modelComp="model"
										:statusColumn="model.newsstatus"
										statusColumnName="newsstatus"
									></statusselectcomponent>
								</v-flex>
							</v-layout>
							<v-layout wrap>
								<v-flex md12 lg12 xs12>
									<pui-text-area
										:label="$t('news.netrshortcontent')"
										v-model="model.netrshortcontent"
										toplabel
										required
										maxlength="200"
									></pui-text-area>
								</v-flex>
							</v-layout>
							<!-- content creator -->
							<v-layout wrap>
								<pui-rich-text-editor
									required
									:validationErrors="formValidationErrors"
									v-model="model.netrcontent"
									:label="getHtmlComponentLabel"
									id="netrcontent"
								></pui-rich-text-editor>
							</v-layout>

							<!-- FIN -->
							<v-layout wrap>
								<v-flex xs12 md6 lg6>
									<pui-field-set :title="getTitleImage" v-if="pkDoc != null">
										<imageuploader
											:modelName="modelName"
											:pk="pkDoc"
											role="news_primary"
											pkName="newsid"
											description="Primary news image"
										/>
									</pui-field-set>
								</v-flex>
								<v-flex md6 lg6 xs12>
									<pui-text-field :label="$t('news.netrtags')" v-model="model.netrtags" toplabel maxlength="100"></pui-text-field>
								</v-flex>
							</v-layout>
						</pui-field-set>
					</v-tab-item>
					<!-- Tab 1 Galeria -->
					<v-tab-item :key="1" :value="`newsGallery`" lazy>
						<pui-master-detail componentName="PuiDocumentGrid" :parentModelName="modelName" :parentPk="pk"></pui-master-detail>
					</v-tab-item>
				</v-tabs-items>
			</div>
			<!-- footer -->
			<pui-form-footer v-if="!isModalDialog">
				<pui-form-footer-btns
					:formDisabled="formDisabled"
					:saveDisabled="saving"
					:saveAndNew="saveAndNew"
					:saveAndUpdate="saveAndUpdate"
					:save="save"
					:back="back"
				></pui-form-footer-btns>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import PuiFormMethodsMixin from 'pui9-mixins/PuiFormMethodsMixin';
import ImageUploader from '@/mixins/ImageUploader.vue';
import StatusSelectComponent from '@/mixins/StatusSelectComponent.vue';

export default {
	name: 'eventnewsform',
	mixins: [PuiFormMethodsMixin],

	components: {
		imageuploader: ImageUploader,
		statusselectcomponent: StatusSelectComponent
	},

	data() {
		return {
			pkDoc: null,
			pkName: 'newsid',
			modelName: 'news',
			tabmodel: 'tabControl',
			parentModelName: 'event',
			parentModelPk: null,
			saving: false,
			isAdminUserOrHigher: false
		};
	},
	methods: {
		afterGetData() {
			this.pkDoc = this.model.newsid;
			this.getParentPk();
			this.checkAdminUser();
		},

		getParentPk() {
			const parentModel = this.$puiUtils.getPathModelMethodPk(this.$router, this.parentModelName);
			if (parentModel != null) {
				const pk = parentModel.pk;
				this.model.newseventid = pk.evenid;
			}
		},

		checkAdminUser() {
			const workingRole = window.localStorage.getItem('workingRole');
			workingRole === 'ADMIN' ? (this.isAdminUserOrHigher = true) : (this.isAdminUserOrHigher = false);
		}
	},

	computed: {
		getTitleImage() {
			return this.$t('label.primaryimage');
		},
		getHtmlComponentLabel() {
			return this.$t('news.netrcontent');
		}
	}
};
</script>

<style lang="css" scoped></style>
